import { STORE_AUDIT_SLICE_NAME } from './storeAudit.const';
import { storeAuditReducer } from './storeAudit.slice';

export const STORE_AUDIT_CONFIG = {
  [STORE_AUDIT_SLICE_NAME]: storeAuditReducer,
};
